import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const Subtotal = (props) => {
	const { data, generateSubtotal, subtotal } = props;

	const navigate = useNavigate();

	React.useEffect(() => {
		if (data.length > 0) {
			generateSubtotal();
		}
	}, [data]);

	return (
		<Stack
			component={Paper}
			sx={{
				width: { xs: 1, md: 1 / 2 },
				mb: { xs: 20, sm: 5 }
			}}
		>
			<Box
				sx={{
					bgcolor: 'lightgrey',
					p: 2
				}}
			>
				<Typography variant='h6' sx={{ fontWeight: 500, fontSize: '1em' }}>
					Card Totals
				</Typography>
			</Box>
			<Stack divider={<Divider />} p={3} mx={2} spacing={3}>
				<Stack direction='row' justifyContent='space-between'>
					<Typography>Subtotal</Typography>
					<Typography>${subtotal}.00</Typography>
				</Stack>
				<Stack direction='row' justifyContent='space-between'>
					<Typography>Total</Typography>
					<Typography>${subtotal}.00</Typography>
				</Stack>
				<Stack alignItems='flex-end'>
					<Button
						sx={{
							textTransform: 'none',
							borderRadius: (theme) => theme.pixels.bRadius.main,
							padding: '10px 25px',
							boxShadow: 'none',
							fontWeight: 600
						}}
						onClick={() => {
							window.scrollTo({ top: 0 });
							navigate('/checkout');
						}}
					>
						Proceed to Checkout
					</Button>
				</Stack>
			</Stack>
		</Stack>
	);
};

Subtotal.propTypes = {
	data: PropTypes.array,
	generateSubtotal: PropTypes.func,
	subtotal: PropTypes.number
};

export default Subtotal;
